// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"verified","clipPath":"url(#clip0_543_7968)"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 1.5L15.2145 4.23941L19.4246 4.57538L19.7606 8.78546L22.5 12L19.7606 15.2145L19.4246 19.4246L15.2145 19.7606L12 22.5L8.78546 19.7606L4.57538 19.4246L4.23941 15.2145L1.5 12L4.23941 8.78546L4.57538 4.57538L8.78546 4.23941L12 1.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 1.5L15.2145 4.23941L19.4246 4.57538L19.7606 8.78546L22.5 12L19.7606 15.2145L19.4246 19.4246L15.2145 19.7606L12 22.5L8.78546 19.7606L4.57538 19.4246L4.23941 15.2145L1.5 12L4.23941 8.78546L4.57538 4.57538L8.78546 4.23941L12 1.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 12L11 15L16.5 9.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const VerifiedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'verified',
    ref,
    icon: element,
  },
));

VerifiedIcon.displayName = 'VerifiedIcon';

export default VerifiedIcon;
